import { throwError as observableThrowError } from 'rxjs';
import { environment } from 'environments/environment';
import { HttpResponse } from '@angular/common/http';

export abstract class ServiceBase {
  public Token = '';

  protected URL_API: string = environment.URL_API;
  protected URL_CACHE: string = environment.URL_CACHE;


  public obterFuncionario() {
    return JSON.parse(localStorage.getItem('Cardeal.Usuario'));
  }

  protected serviceError(error: HttpResponse<Response> | any) {
    let errMsg = '';
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return observableThrowError(errMsg);
  }

  protected extractData(response: Response) {
    const body = response.json();
    return body || {};
  }

  public limpaStringProps(objeto: Object): Object {
    const propriedades = Object.entries(objeto);
    propriedades.forEach((prop) => {
      if (typeof prop[1] === 'string') {
        objeto[prop[0]] = objeto[prop[0]].trim();
      }
    });
    return objeto;
  }

}
